var map = {
	"./address/menus/SettingsMenu": 849,
	"./companies/menus/SettingsMenu": 853,
	"./cost/menus/SettingsMenu": 856,
	"./cost/views/DoomPricesMenu": 250,
	"./cost/views/PricesMenu": 251,
	"./cost/views/additional_services/AdditionalServicesMenu": 81,
	"./cost/views/airport/AirportsMenu": 82,
	"./cost/views/extrasize/FreightExtrasizesMenu": 83,
	"./cost/views/luw/LuwsMenu": 252,
	"./cost/views/manipulator/ManipulatorsMenu": 253,
	"./cost/views/storage/StoragesMenu": 255,
	"./customers/menus/MainMenu": 908,
	"./deals/menus/MainMenu": 914,
	"./deals/menus/SettingsMenu": 915,
	"./finance/menus/MainMenu": 940,
	"./logs/menus/SettingsMenu": 944,
	"./module/menus/MainMenu": 948,
	"./module/menus/SettingsMenu": 949,
	"./reports/menus/MainMenu": 959,
	"./stock/menus/MainMenu": 977,
	"./stock/menus/SettingsMenu": 978,
	"./storekeepers_stocks/menus/MainMenu": 993,
	"./tasks/menus/FavoritesMenu": 1003,
	"./tasks/menus/MainMenu": 1004,
	"./users/menus/SettingsMenu": 1009
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1295;


//////////////////
// WEBPACK FOOTER
// ./src/modules Menu$
// module id = 1295
// module chunks = 0